
export function isAuthenticated() {
  return localStorage.getItem("smo-auth") !== null;
}

export function setAuthentication(authObj) {
  localStorage.setItem("smo-auth", JSON.stringify(authObj));
}

export function getAuthentication() {
  return JSON.parse(localStorage.getItem("smo-auth"));
}

export function clearAuthentication() {
  localStorage.removeItem("smo-auth");
}


export function isAdmin() {
  return getAuthentication().email === "admin@smic.com"
}